<div style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet o-block u-width-100p _u-width-100p stats-container u-shadow-mini {{
			sectionclass
		}} u-color-white-900 u-bg-accent-2"
	>
		<div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap">
			<div class="o-stack__cell">
				<h5 class="u-color-white-900">{{ sectiontitle }}</h5>
				<span *ngIf="downloadConfiguration.enableDownload && hasData" class="datatable-icon">
					<a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV($event)" target="_blank">
						<i class="fa fa-download" aria-hidden="true"></i>
					</a>
				</span>
			</div>
		</div>
		<div class="analytics-portlet-content u-pt-small lift_quick_stats_portlet_content r1_ctv_quick_stats">
			<div class="o-stack o-stack--center _u-px-small" *ngIf="quickStatsData && hasData">
				<span
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Number of ads shown to users"
					data-size="big"
					[options]="tooltipOptions"
				>
					<h5 class="u-color-white-900">Impressions</h5>
					<span
						class="u-font-medium u-lh-normal u-opacity-80p"
						*ngIf="quickStatsData.impressions; else impressionsblock"
						>{{ quickStatsData.impressions | formatNumber }}</span
					>
					<ng-template #impressionsblock>
						<span class="u-font-small u-lh-normal u-opacity-80p"> -- </span>
					</ng-template>
				</span>

				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="When a video ad starts and plays through its entire duration to completion"
					data-size="big"
					[options]="tooltipOptions"
				>
					<h5 class="u-color-white-900">Completions</h5>
					<span
						class="u-font-medium u-lh-normal u-opacity-80p"
						*ngIf="quickStatsData.completions; else completionsBlock"
					>
						{{ quickStatsData.completions | formatNumber }}
					</span>
					<ng-template #completionsBlock>
						<div class="u-color-white-900 span_intraction">--</div>
					</ng-template>
				</div>

				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Percent of video ads that are played through their entire duration to completion"
					data-size="big"
					[options]="tooltipOptions"
				>
					<h5 class="u-color-white-900">Completion Rate</h5>
					<span
						class="u-font-medium u-lh-normal u-opacity-80p"
						*ngIf="quickStatsData.completionsPercentage; else completionsRateBlock"
					>
						{{ quickStatsData.completionsPercentage }}%
					</span>
					<ng-template #completionsRateBlock>
						<div class="u-color-white-900 span_intraction">--</div>
					</ng-template>
				</div>

				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Visits to target webpage(s) by users in households who were shown an ad on a connected TV device"
					data-size="big"
					[options]="tooltipOptions"
				>
					<h5 class="u-color-white-900">Website Attribution</h5>
					<span
						class="u-font-medium u-lh-normal u-opacity-80p"
						*ngIf="quickStatsData.websiteAttributions; else websiteAttributionsBlock"
					>
						{{ quickStatsData.websiteAttributions | formatNumber }}
					</span>
					<ng-template #websiteAttributionsBlock>
						<div class="u-color-white-900 span_intraction">--</div>
					</ng-template>
				</div>
			</div>
			<div *ngIf="!hasData" class="map-no-data">No Data to Display</div>
		</div>
	</div>
</div>
